import i18n from 'i18next';

interface AgeGroup {
  from: number;
  to: number;
  label: string;
}

const ageGroups: AgeGroup[] = [
  {
    from: 0,
    to: 17,
    get label() {
      return i18n.t('constants:младше 18');
    },
  },
  {
    from: 18,
    to: 44,
    get label() {
      return i18n.t('constants:от 18 до 44');
    },
  },
  {
    from: 45,
    to: 60,
    get label() {
      return i18n.t('constants:от 45 до 60');
    },
  },
  {
    from: 61,
    to: 100,
    get label() {
      return i18n.t('constants:старше 60');
    },
  },
];

export const determinerAgeGroup = (value?: number | null): AgeGroup | undefined => {
  if (value == null) return undefined;

  return ageGroups.find(({ from, to }) => from <= value && value <= to);
};
